import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { Delete, Get, Post, Put } from '@/api/api-middleware';

import { apiPath } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';
const initialState = {
  reportTypeDetailsList: [],
  loading: false,
  error: '',
};

export const GetReportTypeByMasterId = createAsyncThunk(
  'reportType/GetReportTypeByMasterId',
  async (params, thunkAPI) => {
    try {
      const response = await Get({
        url: `${apiPath}${
          'api/Lookup/ReportTypeDetails/GetAllByMasterId/' + params.Id
        }`,
      });
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          value: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          code: item.code,
          parentID: item?.parentID,
          parent: item?.parent?.nameEn,
          levelID: item?.level?.id,
          level: item?.level?.nameEn,
        })) ?? [];

      return mappedData;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// export const fetchEntity = createAsyncThunk(
//   'entitity/fetchEntity',
//   async (params, thunkAPI) => {
//     try {
//       const response = await Lookup.GetEntity();
//       const mappedData =
//         response?.data?.data?.map((item) => ({
//           id: item.id,
//           value: item.id,
//           nameEn: item.nameEn,
//           nameAr: item.nameAr,
//           label: item.nameEn,
//           code: item.code,
//           parentID: item?.parentID,
//           parent: item?.parent?.nameEn,
//           levelID: item?.level?.id,
//           level: item?.level?.nameEn,
//         })) ?? [];

//       return [firstListItem, ...mappedData];
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

const reportTypeSlice = createSlice({
  name: 'reportType',
  initialState,
  reducers: {
    // addNewEntity: (state, action) => {
    //   state.entityList = [
    //     {
    //       id: action.payload.id,
    //       value: action.payload.id,
    //       nameEn: action.payload.nameEn,
    //       nameAr: action.payload.nameAr,
    //       label: action.payload.nameEn,
    //       code: action.payload.code,
    //       parentID: action.payload?.parentID,
    //       parent: action.payload?.parent,
    //       levelID: action.payload?.levelID,
    //       level: action.payload?.level,
    //     },
    //     ...state.entityList,
    //   ];
    //   state.loading = false;
    //   state.error = '';
    // },
    // updateEntity: (state, action) => {
    //   const updatedItem = {
    //     id: action.payload.id,
    //     value: action.payload.id,
    //     nameEn: action.payload.nameEn,
    //     nameAr: action.payload.nameAr,
    //     label: action.payload.nameEn,
    //     code: action.payload.code,
    //     parentID: action.payload?.parentID,
    //     parent: action.payload?.parent,
    //     levelID: action.payload?.levelID,
    //     level: action.payload?.level,
    //   };
    //   const updatedList = state.entityList
    //     .filter((x) => x.id != '')
    //     .map((item) =>
    //       item.id === updatedItem.id ? { ...item, ...updatedItem } : item
    //     );
    //   state.entityList = [...updatedList, firstListItem];
    //   state.loading = false;
    //   state.error = '';
    // },
    // deleteEntity: (state, action) => {
    //   const filteredList = state.entityList.filter(
    //     (item) => item.id !== action.payload
    //   );
    //   state.entityList = filteredList;
    //   state.loading = false;
    //   state.error = '';
    //   console.log(state.entityList);
    // },
  },
  extraReducers: (builder) => {
    // builder
    //   .addCase(fetchEntity.pending, (state) => {
    //     state.loading = true;
    //   })
    //   .addCase(fetchEntity.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.entityList = action.payload;
    //     state.error = '';
    //   })
    //   .addCase(fetchEntity.rejected, (state, action) => {
    //     state.loading = false;
    //     state.entityList = [];
    //     state.error = action.payload ?? 'An error occurred';
    //   });

    builder
      .addCase(GetReportTypeByMasterId.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetReportTypeByMasterId.fulfilled, (state, action) => {
        state.loading = false;
        const reportTypeDetailsList = action.payload;
        if(reportTypeDetailsList && reportTypeDetailsList?.length > 0){
          state.reportTypeDetailsList = reportTypeDetailsList.map((item) => ({
            ...item,
            label: getLabel(item.nameAr, item.nameEn),
          }));
        }else{
          state.reportTypeDetailsList = reportTypeDetailsList;
        }
        state.error = '';
      })
      .addCase(GetReportTypeByMasterId.rejected, (state, action) => {
        state.loading = false;
        state.reportTypeDetailsList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

// export const { addNewEntity, updateEntity, deleteEntity } = entitySlice.actions;
export default reportTypeSlice.reducer;
